module.exports = __webpack_public_path__ + "img/discover.000a137d.svg";